import {FC, useEffect, useRef, useState} from 'react'
import useUser from '../../../hooks/User'
import {useIntl} from 'react-intl'
import * as ExcelJS from 'exceljs'
import axios from 'axios'
import useAccessToken from '../../../hooks/AccessToken'
import useSWR from 'swr'
import {IComponent, ISection, ITemplateAnalytic} from '../../../interfaces/Analytics/Analytics'
import {useAnalyticsStore} from '../../../stores/Analytics/AnalyticStore'
import AddSection from '../../../components/Analytics/Section/AddSection'
import UpdateSection from '../../../components/Analytics/Section/UpdateSection'
import {DeleteSection} from '../../../components/Analytics/Section/DeleteSection'
import SectionAnalytics from '../../../components/Analytics/Section/SectionAnalytics'
import useModalEffect from '../../../hooks/useModalEffect'
import AddComponent from '../../../components/Analytics/Component/AddComponent'
import UpdateComponent from '../../../components/Analytics/Component/UpdateComponent'
import {DeleteComponent} from '../../../components/Analytics/Component/DeleteComponent'
import zoomPlugin from 'chartjs-plugin-zoom'
import {Chart as ChartJS} from 'chart.js'
import html2canvas from 'html2canvas'
import {Link, useParams} from 'react-router-dom'
import {customNumberFormat, formatTimeByFrame, truncateText} from '../../../functions/general'
import useAnalyticGuard from '../../../functions/Guard/analyticGuard'
import useDynamicTab from '../../../hooks/useDynamicTab'
import {
  closestCorners,
  defaultDropAnimationSideEffects,
  DndContext,

  DropAnimation,
  KeyboardSensor,
  PointerSensor,
  TouchSensor,
  UniqueIdentifier,
  useSensor,
  useSensors,
} from '@dnd-kit/core'
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable'
import { updatePositionAnalytic } from '../../../api/Analitik/TemplateCRUD'
import Swal from 'sweetalert2'
import InstallAnalyticDashboard from '../../../components/Analytics/Component/InstallAnalyticDashboard'

export declare type ValueType = [Date?, Date?]
export declare type DateRange = [Date, Date]
export interface RangeType {
  label: React.ReactNode
  value: DateRange | ((value?: ValueType) => DateRange)
  closeOverlay?: boolean
  placement?: 'bottom' | 'left'
}

export interface ITranformDataExport {
  name: string
  header: string[]
  data: any
  id: string
  type: string
}
export interface ISectionComponentMap {
  sectionId: string
  listComponentId: string[]
}

const Analytics: FC = () => {
  const intl = useIntl()
  const token = useAccessToken()
  const user = useUser()
  const { isCanEditTemplate, isOwnerTemplate} = useAnalyticGuard(user)

  useEffect(() => {
    ChartJS.register(zoomPlugin)
  }, [])
  const componentToExportRef = useRef(null)
  const [templateAnalyticName, setTemplateAnalyticName] = useState('')
  const [showUpdateSectionModal, setShowUpdateSectionModal] = useState<boolean>(false)
  const [showDeleteSectionModal, setShowDeleteSectionModal] = useState<boolean>(false)
  const [section, setSection] = useState<ISection>()
  const [exportingLoading, setExportingLoading] = useState(false)
  const API_URL = process.env.REACT_APP_API_URL
  const {
    showUpdateComponentModal,
    setShowUpdateComponentModal,
    components,
    setComponents,
    sections,
    setSections,
    showDeleteComponentModal,
    setShowDeleteComponentModal,
    templatesAnalytic,
    setComponentsLoading,
    component,
    templateAnalytic,
    setTemplateAnalytic,
    setLimitComponentData,
    limitComponentData,
    setActiveAnalyticDND,
    setSectionDragging,
    setShowInstallAnalyticDashboardModal,
    showInstallAnalyticDashboardModal
  } = useAnalyticsStore()
  const [showAddComponentModal, setShowAddComponentModal] = useState(false)
  const [analyticsPositionTemp, setAnalyticPositionTemp] = useState<ISectionComponentMap[]>()
  const [analyticsPosition, setAnalyticPosition] = useState<ISectionComponentMap[]>()
  const [analyticPositionStatus, setAnalyticPositionStatus] = useState<boolean>(true)
  const dropAnimation: DropAnimation = {
    sideEffects: defaultDropAnimationSideEffects({
      styles: {
        active: {
          opacity: '0.5',
        },
      },
    }),
  }
  const fetcher = (url: string) =>
    axios
      .get(url, {
        headers: {
          'X-Auth-token': token,
        },
      })
      .then((res) => res.data.data)
      .catch((error) => {
        throw error.response ? error.response.data : error
      })
  useDynamicTab({title: `${intl.formatMessage({id: 'MENU.ANALYTICS'})} | CRM WooBlazz`})

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(TouchSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  )
  const {templateAnalyticId} = useParams()

  const {
    data: sectionData = [],
    error: sectionError,
    isLoading: sectionLoading,
    isValidating: sectionValidating,
  } = useSWR(`${API_URL}menu-analytics?templateId=${templateAnalyticId}`, fetcher)

  const {
    data: componentData = [],
    error: componentError,
    isLoading: componentLoading,
    isValidating: compoenentValidating,
  } = useSWR(`${API_URL}menu-analytics/data?templateId=${templateAnalyticId}`, fetcher)

  const {
    data: sectionComponentMapData = [],
    error: sectionComponentMapError,
    isLoading: sectionComponentIsLoading,
    isValidating: sectionComponentMapisValidating,
  } = useSWR(`${API_URL}/menu-analytics/position?templateId=${templateAnalyticId}`, fetcher)

  const {
    data: _limitComponentData = [],
    error: limitComponentError,
    isLoading: limitComponentLoading,
  } = useSWR(`${API_URL}/menu-analytics/limit`, fetcher)
  const handleEditSection = (section: ISection) => {
    setShowUpdateSectionModal(true)
    setSection(section)
  }
  const handleAddComponent = (section: ISection) => {
    setShowAddComponentModal(true)
    setSection(section)
  }
  const handleDeleteSection = (section: ISection) => {
    setShowDeleteSectionModal(true)
    setSection(section)
  }

  const handleExport = async () => {
    setExportingLoading(true)
    const transformComponentDataToExport = (component: IComponent): ITranformDataExport => {
      const name = component.nameComponent
      const header = [
        intl.formatMessage({id: 'FORM.ACTION.DATE'}),
        ...component.dataCore.map((core) => core.name),
      ]
      const lengthDataComponent = component.dataCore[0].data.length
      const allDate = component.dataCore[0].data.map((core) =>
        formatTimeByFrame(core.time, component.timeFrame)
      )

      const data = Array.from({length: lengthDataComponent}, (_, indexRow) => {
        const value = component.dataCore.map((core, indexCol) => ({
          [header[indexCol + 1]]: core.data[indexRow].value,
        }))

        return {
          Tanggal: allDate[indexRow],
          ...Object.assign({}, ...value),
        }
      })

      return {name, header, data, id: component.componentId, type: component.chartType}
    }

    const worksheetsData = componentData.map(transformComponentDataToExport)
    const workbook = new ExcelJS.Workbook()

    // **Gunakan Promise.all untuk menunggu semua proses html2canvas selesai**
    await Promise.all(
      worksheetsData.map(async (worksheetData: ITranformDataExport) => {
        const element = document.getElementById(`component-${worksheetData.id}-export`)
        if (!element) {
          return
        }

        const worksheet = workbook.addWorksheet(worksheetData.name)

        // Menambahkan header
        const headerRow = worksheet.addRow(worksheetData.header)
        headerRow.font = {bold: true, color: {argb: '000000'}, size: 12}
        headerRow.alignment = {horizontal: 'center'}

        worksheetData.header.forEach((_, index) => {
          const cell = worksheet.getCell(1, index + 1)
          cell.fill = {type: 'pattern', pattern: 'solid', fgColor: {argb: 'FFA500'}}
          cell.border = {
            top: {style: 'thin'},
            left: {style: 'thin'},
            right: {style: 'thin'},
            bottom: {style: 'thin'},
          }
          worksheet.getColumn(index + 1).width = 20
        })

        // Menambahkan data ke worksheet
        worksheetData.data.forEach((item: any) => {
          const row = worksheet.addRow(Object.values(item))
          row.eachCell((cell) => {
            if (typeof cell.value === 'number') {
              cell.numFmt = '#,##0'
            }
          })
        })

        // **Ambil elemen dan render ke canvas**
        if (element && worksheetData.type !== 'LIST') {
          try {
            const canvas = await html2canvas(element)
            const imgData = canvas.toDataURL('image/png')
            const imageId = workbook.addImage({base64: imgData, extension: 'png'})

            worksheet.addImage(imageId, {
              tl: {col: worksheetData.header.length + 2, row: 1}, // Atur posisi gambar
              ext: {width: canvas.width, height: canvas.height},
            })
          } catch (error) {
            console.error(`Gagal menangkap elemen dengan ID: component-${worksheetData.id}`, error)
          }
        }
      })
    )

    // **Setelah semua proses selesai, baru buat file Excel**
    const buffer = await workbook.xlsx.writeBuffer()
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = `${templateAnalyticName}.xlsx`
    link.click()
    setExportingLoading(false)
  }

  const findContainer = (id: UniqueIdentifier) => {
    if (components.some((component) => component.componentId === id)) {
      const index = components.findIndex((component) => component.componentId === id)
      const sectionid = components[index].sectionId
      return sectionid
    }

    return id as string
  }
  useModalEffect({
    showModal: showDeleteSectionModal,
    setShowModal: setShowDeleteSectionModal,
    modalId: `delete-section-modal-${section?.sectionId}`,
  })

  useModalEffect({
    showModal: showAddComponentModal,
    setShowModal: setShowAddComponentModal,
    modalId: `add-component-modal`,
  })

  useModalEffect({
    showModal: showUpdateSectionModal,
    setShowModal: setShowUpdateSectionModal,
    modalId: `update-section-modal-${section?.sectionId}`,
  })

  useModalEffect({
    showModal: showUpdateComponentModal,
    setShowModal: setShowUpdateComponentModal,
    modalId: `update-component-modal-${component?.componentId}`,
  })
  useModalEffect({
    showModal: showDeleteComponentModal,
    setShowModal: setShowDeleteComponentModal,
    modalId: `delete-component-modal-${component?.componentId}`,
  })
  useModalEffect({
    showModal: showInstallAnalyticDashboardModal,
    setShowModal: setShowInstallAnalyticDashboardModal,
    modalId: `install-analytic-dasboard-modal-${component?.componentId}`,
  })

  // Useffect : save update position
  useEffect(() => {
    const groupedBySection: ISectionComponentMap[] = []
    sections.forEach((item) => {
      const existingSectionIndex = groupedBySection.findIndex(
        (group) => group.sectionId === item.id
      )

      if (existingSectionIndex === -1) {
        groupedBySection.push({
          sectionId: item.sectionId,
          listComponentId: [],
        })
      }
    })
    components.forEach((item) => {
      const existingSectionIndex = groupedBySection.findIndex(
        (group) => group.sectionId === item.sectionId
      )

      if (existingSectionIndex !== -1) {
        groupedBySection[existingSectionIndex].listComponentId.push(item.componentId)
      } else {
        groupedBySection.push({
          sectionId: item.sectionId,
          listComponentId: [item.componentId],
        })
      }
    })

    setAnalyticPositionTemp(groupedBySection)
  }, [components, sections])

  useEffect(() => {
    if (!sectionComponentIsLoading) {
      setAnalyticPosition(sectionComponentMapData)
    }
  }, [sectionComponentMapData])

  useEffect(() => {
    const identic = JSON.stringify(analyticsPosition) === JSON.stringify(analyticsPositionTemp)
    if (!identic) {
      setAnalyticPositionStatus(false)
      const timeout = setTimeout(async() => {
        try {
          const response = await updatePositionAnalytic(analyticsPositionTemp as ISectionComponentMap[], templateAnalyticId as string ,token)
          if(response.data.success){
            setAnalyticPosition(response.data.data)
          }
        } catch (error:any) {
           Swal.fire({
                    icon: 'error',
                    title: error.response.data.message,
                    confirmButtonText: 'Ok',
            })
        }
      }, 2000)

      return () => {
        clearTimeout(timeout) // bersihkan timer kalau ada perubahan sebelum 2 detik
      }
    }
    if (identic) {
      setAnalyticPositionStatus(true)
    }
  }, [analyticsPosition, analyticsPositionTemp])
  // Useffect : save update position
  useEffect(() => {
    if (!limitComponentLoading) {
      setLimitComponentData(_limitComponentData)
    }
  }, [_limitComponentData])

  useEffect(() => {
    const identic = JSON.stringify(sections) === JSON.stringify(sectionData)
    if(!identic){
      setSections(sectionData)
    }
  }, [sectionData])

  useEffect(() => {
    const identic = JSON.stringify(componentData) === JSON.stringify(components)
    if(!identic){
      setComponents(componentData)
    }
  }, [componentData])

  useEffect(() => {
    setComponentsLoading(componentLoading)
  }, [componentLoading])

  useEffect(() => {
    const name =
      templatesAnalytic?.find((template: ITemplateAnalytic) => template.id === templateAnalyticId)
        ?.name || ''
    const template = templatesAnalytic?.find(
      (template: ITemplateAnalytic) => template.id === templateAnalyticId
    )
    if (template) {
      setTemplateAnalytic(template)
    }

    setTemplateAnalyticName(name)
  }, [templatesAnalytic])

  return (
    <>
      <div className='row justify-content-between mb-3'>
        <div className='col-sm-3 col-lg-4 col-xl-5 d-flex gap-4' style={{alignSelf: 'center'}}>
          <ol className='breadcrumb text-muted fs-6 fw-bold'>
            <li className='breadcrumb-item pe-3'>
              <Link to={`/analytics`} className='text-muted text-hover-primary'>
                {intl.formatMessage({id: 'MENU.ANALYTICS'})}
              </Link>
            </li>
            <li className='breadcrumb-item text-dark'>{truncateText(templateAnalyticName, 25)}</li>
          </ol>
          {analyticPositionStatus ? <i className='bi bi-cloud-check-fill fs-1' /> :   <span className='spinner-border spinner-border-sm align-middle ms-2'></span>}
        </div>
        <div className='col-sm-9 col-lg-8 col-xl-7'>
          <div className='d-flex px-3 float-end gap-2 align-items-center'>
            <div className='d-flex align-items-center w-200px flex-column me-5'>
              <div className='d-flex justify-content-between w-100 mt-auto mb-2'>
                <span className='fw-bold fs-6 text-gray-400'>
                  {intl.formatMessage({id: 'FORM.LABEL.COMPONENT_ANALYTIC_LIMIT'})}
                </span>
                <span className='fw-bolder fs-6'>
                  {customNumberFormat(limitComponentData?.componentAnalyticCount ?? 0)} /{' '}
                  {customNumberFormat(limitComponentData?.limitComponentAnalytic ?? 0)}
                </span>
              </div>
              <div className='h-5px mx-3 w-100 mb-3' style={{backgroundColor: 'white'}}>
                <div
                  className='bg-success rounded h-5px'
                  role='progressbar'
                  style={{
                    width:
                      Math.round(
                        (limitComponentData?.componentAnalyticCount /
                          limitComponentData?.limitComponentAnalytic) *
                          100
                      ) + '%',
                  }}
                ></div>
              </div>
            </div>
            <button
              className='btn btn btn-light-success mt-3'
              onClick={handleExport}
              disabled={componentLoading || exportingLoading}
            >
              {componentLoading || exportingLoading ? (
                <>
                  <i className='fas fa-file-download fs-2 me-2'></i> Loading ...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </>
              ) : (
                <>
                  <i className='fas fa-file-download fs-2 me-2'></i>
                  {intl.formatMessage({id: 'MASTERS.DATATABLE.ACTIONS.EXPORT_EXCEL'})}
                </>
              )}
            </button>
            {(isCanEditTemplate(templateAnalyticId || '') ||
              (templateAnalytic && isOwnerTemplate(templateAnalytic))) && <AddSection />}
          </div>
        </div>
      </div>
      {sectionLoading && (
        <div className='loading-overlay'>
          <div className='loader'></div>
        </div>
      )}
      <div ref={componentToExportRef}>
        {!sectionLoading && (
          <DndContext
            onDragStart={({active}) => {
              setActiveAnalyticDND(active)
              if(active.data.current?.type==="section"){
                setSectionDragging(true)
              }
              
            }}
          
            onDragOver={({active, over}) => {
              const overId = over?.id

              if (overId == null) {
                return
              }

              const overContainer = findContainer(overId)
              const activeContainer = findContainer(active.id)
              if (
                overContainer &&
                activeContainer !== overContainer &&
                active.data?.current?.type === 'component'
              ) {
                setComponents(
                  components.map((component) => {
                    if (active.id === component.componentId) {
                      return {...component, sectionId: overContainer}
                    }
                    return component
                  })
                )
              }
            }}
            onDragEnd={({active, over}) => {
              const overId = over?.id

              if (active.data?.current?.type === 'section') {
                const newSections = (sections: ISection[]) => {
                  const activeIndex = sections.findIndex(
                    (section) => section.sectionId === active.id
                  )
                  const overIndex = sections.findIndex((section) => section.sectionId === over?.id)
                  setSectionDragging(false)
                  return arrayMove(sections, activeIndex, overIndex)
                }

                return setSections(newSections(sections))
              }

              if (overId) {
                const newComponents = (components: IComponent[]) => {
                  const activeIndex = components.findIndex(
                    (component) => component.componentId === active.id
                  )
                  const overIndex = components.findIndex(
                    (component) => component.componentId === over.id
                  )

                  return arrayMove(components, activeIndex, overIndex)
                }

                setComponents(newComponents(components))
              }

              setActiveAnalyticDND(null)
            }}
            onDragCancel={({active}) => {
              setActiveAnalyticDND(null)
              if(active.data.current?.type==="section"){
                setSectionDragging(true)
              }
            }}
            sensors={sensors}
            collisionDetection={closestCorners}
          >
            <SortableContext items={sections}>
              {sections.map((menu) => {
                return (
                  <SectionAnalytics
                    key={menu.sectionId}
                    handleDeleteSection={handleDeleteSection}
                    handleEditSection={handleEditSection}
                    menu={menu}
                    handleAddComponent={handleAddComponent}
                    components={components.filter(
                      (component: IComponent) => component.sectionId === menu.sectionId
                    )}
                  />
                )
              })}
            </SortableContext>
          </DndContext>
        )}

        {!sectionLoading && sections.length <= 0 && (
          <>
            <div className=' card p-8'>
              <div className='w-100 h-100 d-flex justify-content-center align-items-center gap-4 flex-column'>
                {/* <i className='bi bi-emoji-frown' style={{fontSize: '12rem'}} />{' '} */}
                <span style={{fontSize: '1.5rem', color: '#A1A5B7'}}>
                  {intl.formatMessage(
                    {id: 'FORM.CONFIRM.DATA_EMPTY'},
                    {
                      title: intl.formatMessage({id: 'MENU.ANALYTICS'}),
                    }
                  )}
                </span>
              </div>
            </div>
          </>
        )}
        {showUpdateSectionModal && <UpdateSection section={section!} />}
        {showDeleteSectionModal && <DeleteSection section={section!} />}
        {showDeleteComponentModal && <DeleteComponent component={component!} />}
        {showAddComponentModal && <AddComponent section={section!} />}
        {showUpdateComponentModal && <UpdateComponent component={component!} section={section!} />}
        {showInstallAnalyticDashboardModal && <InstallAnalyticDashboard component={component!}  />}
      </div>
    </>
  )
}

export {Analytics}
